"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var MODAL_FOOTER_ALIGN = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
  SPACE_BETWEEN: 'space-between',
  SPACE_AROUND: 'space-around'
};
var _default = MODAL_FOOTER_ALIGN;
exports["default"] = _default;